<template>
    <div class="container text-center">
        <form class="form-signin" @submit.prevent="login">
            <h1 class="h3 mb-3 font-weight-normal">Autentifica-te</h1>
            <label for="email" class="sr-only">Email</label>
            <input v-model="username" type="email" id="email" class="form-control" placeholder="Email address" required="" autofocus="" autocomplete="current-user">
            <label for="password" class="sr-only">Parola</label>
            <input v-model="password" type="password" id="password" class="form-control" placeholder="Password" required="" autocomplete="current-password">
            <div class="checkbox mb-3">
                <label>
                    <input type="checkbox" value="remember-me" v-model="remember"> Remember me
                </label>
            </div>
            <button class="btn btn-lg btn-primary btn-block" type="submit">Log in</button>
        </form>
    </div>
</template>

<script>
    import {AUTH_REQUEST} from '../store/types'
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        data: () => {
            return {
                username: '',
                password: '',
                remember: false
            }
        },
        methods: {
            login(){
                const { username, password, remember } = this;
                this.$store.dispatch('auth/'+AUTH_REQUEST, { username, password, remember }).then(() => {
                    console.log('logged in');
                    this.$router.push('/')
                })
            }
        }
    }
</script>

<style scoped>
.form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
}
.form-signin .checkbox {
    font-weight: 400;
}
.form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
}
.form-signin .form-control:focus {
    z-index: 2;
}
.form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
</style>